import services from '@/services/api/location.api';
import getParentInventoryServices from '@/services/api/parentInventory.api';

export default {
  loadMountedData(context) {
    let isEmptyAcademicYears = context.state.academicYears.length == 0;
    let isEmptyStatus = context.state.sampleInventoryStatuses.length == 0;

    if (isEmptyAcademicYears) {
      context.dispatch('loadAcademicYears');
    } else {
      let reload = context.state.canResearch;

      if (reload) {
        context.commit('reset');
        context.dispatch('loadCurrentAcademicYear');
      } else {
        context.commit('setCanResearch', true);
      }
    }

    if (isEmptyStatus) {
      context.dispatch('loadSampleInventoryStatuses');
    }
  },
  loadAcademicYears(context) {
    getParentInventoryServices
      .getSampleInventoryAcademicYears()
      .then(({ data }) => {
        context.commit('setAcademicYears', data);
        context.dispatch('loadCurrentAcademicYear');
      });
  },
  loadCurrentAcademicYear({ commit, dispatch, state }) {
    commit('setValue', {
      property: 'selectedAcademicYear',
      data: state.academicYears[0] ?? null,
    });
    dispatch('loadRegions');
  },
  loadRegions(context) {
    let { selectedAcademicYear } = context.state;
    if (!selectedAcademicYear) {
      context.commit('setValue', {
        property: 'selectedRegion',
        data: null,
      });

      context.dispatch('loadDistricts');
      return;
    }

    services
      .getRegions({ AcademicYearId: selectedAcademicYear.id })
      .then(({ data }) => {
        context.commit('setRegions', data);

        if (data.length == 1) {
          context.commit('setValue', {
            property: 'selectedRegion',
            data: data[0],
          });
          context.dispatch('loadDistricts');
        }
      });
  },
  loadSampleInventoryStatuses(context) {
    getParentInventoryServices.getSampleInventoryStatuses().then(({ data }) => {
      data.unshift({ id: -1, name: 'Todos' });
      context.commit('setStatuses', data);
    });
  },
  loadDistricts(context) {
    let { selectedAcademicYear, selectedRegion } = context.state;
    if (selectedAcademicYear == null || selectedRegion == null) return;

    services
      .getDistricts({
        RegionId: selectedRegion.id,
        AcademicYearId: selectedAcademicYear.id,
      })
      .then(({ data }) => {
        context.commit('setDistricts', data);

        if (data.length == 1) {
          context.commit('setValue', {
            property: 'selectedDistrict',
            data: data[0],
          });
        }
        context.dispatch('loadSchools');
      });
  },
  loadSchools(context) {
    let { selectedAcademicYear, selectedDistrict } = context.state;
    if (selectedAcademicYear == null || selectedDistrict == null) return;

    if (!selectedAcademicYear || !selectedDistrict) {
      context.commit('setValue', {
        property: 'selectedSchool',
        data: null,
      });
      return;
    }

    services
      .getSchools({
        DistrictId: selectedDistrict.id,
        AcademicYearId: selectedAcademicYear.id,
      })
      .then(({ data }) => {
        context.commit('setSchools', data);
      });
  },
  loadResults(context, filterProperties) {
    getParentInventoryServices
      .getParentinventoryitems(filterProperties)
      .then(({ data }) => {
        data.data.forEach((element) => {
          element.isOpen = false;
        });

        context.dispatch('loadDashboardCounters', filterProperties).then(() => {
          context.commit('setItemsResult', data.data);

          context.commit('setPagination', {
            count: data.count,
            totalItemCount: data.totalItemCount,
            pageCount:
              data.pageCount || Math.ceil(data.totalItemCount / data.count),
            currentPage: data.currentPage,
            totalPages: data.pageCount,
            totalRecords: data.totalItemCount,
            pageSize: 10,
          });
        });
      });
  },
  loadDashboardCounters(context, filterProperties) {
    getParentInventoryServices
      .getParentinventorycounters(filterProperties)
      .then(({ data }) => {
        context.commit('setDashboard', {
          counters: [
            { key: 'Nuevos:', value: data.new },
            { key: 'Completados:', value: data.completed },
            { key: 'Cancelados:', value: data.canceled },
            { key: 'Notificados:', value: data.notified },
          ],
          circleValue: parseInt(
            Math.round((data.completed / data.total) * 100, 0)
          ),
        });
      });
  },
};
